<template>
  <div class="page-content">
    
    <v-card class="mx-auto elevation-2 tabs-card mt-5">
      <v-container fluid>
        <v-row align="center" justify="space-between">
          <v-tabs v-model="activeTab" class="dashboard-tab" show-arrows next-icon="mdi-arrow-right-bold-box-outline" prev-icon="mdi-arrow-left-bold-box-outline">
            <v-tab value="studio">Studio</v-tab>
            <v-tab v-for="tab in tabs" :key="tab.value" :value="tab.value">{{ tab.label }}</v-tab>
          </v-tabs>
        </v-row>
      </v-container>
    </v-card>

    <v-row justify="space-around" class="mt-5">
      <v-col cols="12" md="3">
        <v-card :class="['elevation-2', activeCard === 'registerSales' ? 'active-card' : '']" @click="setActiveCard('registerSales')" style="min-height: 180px; border-radius: 6px;">
          <v-card-title class="position-relative d-flex align-center" style="padding: 8px 16px;">
            <v-icon size="28" class="mr-2">mdi-cash-register</v-icon>
            <span class="position-center" style="font-size: 16px; font-weight: 600;">Sales Entry</span>
          </v-card-title>
          <v-card-text style="padding: 4px 16px; padding-bottom: 40px;">
            <v-date-input v-model="registerSalesDate" label="Select Date" prepend-icon="" color="primary" hide-actions placeholder="yyyy/mm/dd" :readonly="editableTable"></v-date-input>
          </v-card-text>
          <v-card-actions class="justify-center mt-n4 mb-4" style="position: absolute; bottom: 0; width: 100%;">
            <v-btn
              v-if="!editableTable"
              :class="['btn-primary', activeCard === 'registerSales' ? 'active-button' : '']"
              style="padding: 0 40px; height: 36px; margin-top: 25px;font-size: 14px; background-color: #1976d2; color: white;"
              @click="registerSalesCard"
            >
              Register
            </v-btn>
            <v-btn
              v-else
              icon
              style="margin-left: 6px; background-color: #1976d2; color: white; height: 36px; width: 36px; padding: 0; margin-top: 25px;"
              @click="saveSalesData"
            >
              <v-icon size="28" style="line-height: 36px;">mdi-content-save</v-icon>
            </v-btn>
            <v-btn
              v-if="editableTable"
              icon
              style="margin-left: 6px; background-color: #e53935; color: white; height: 36px; width: 36px; padding: 0; margin-top: 25px;"
              @click="cancelRegisterSales"
            >
              <v-icon size="28" style="line-height: 36px;">mdi-close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="3">
        <v-card :class="['elevation-2', activeCard === 'dailySales' ? 'active-card' : '']" @click="setActiveCard('dailySales')" style="min-height: 180px; border-radius: 6px;">
          <v-card-title class="position-relative d-flex align-center" style="padding: 8px 16px;">
            <v-icon class="mr-2" size="28">mdi-calendar</v-icon>
            <span class="position-center" style="font-size: 16px; font-weight: 600;">Daily Sales</span>
          </v-card-title>
          <v-card-text style="padding: 4px 16px; padding-bottom: 40px;">
            <v-date-input v-model="dailySalesDate" label="Select Date" prepend-icon="" hide-actions placeholder="yyyy/mm/dd"></v-date-input>
          </v-card-text>
          <v-card-actions class="justify-center mt-n4 mb-4" style="position: absolute; bottom: 0; width: 100%;">
            <v-btn :class="['btn-secondary', activeCard === 'dailySales' ? 'active-button' : '']" style="padding: 0 40px; height: 36px; font-size: 14px; background-color: #000000; color: white;" @click="dailySalesCard">View</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="3">
        <v-card :class="['elevation-2', activeCard === 'dateRange' ? 'active-card' : '']" @click="setActiveCard('dateRange')" style="min-height: 180px; border-radius: 6px;">
          <v-card-title class="position-relative d-flex align-center" style="padding: 8px 16px;">
            <v-icon class="mr-2" size="28">mdi-calendar-multiple</v-icon>
            <span class="position-center" style="font-size: 16px; font-weight: 600;">Date Range</span>
          </v-card-title>
          <v-card-text style="padding: 4px 16px; padding-bottom: 40px;">
            <v-date-input v-model="dateSelectRange" label="Select Range" prepend-icon="" max-width="368" multiple="range" @update:modelValue="handleDateRangeSelection" ref="datePicker"/>
          </v-card-text>
          <v-card-actions class="justify-center mt-n4 mb-4" style="position: absolute; bottom: 0; width: 100%;">
            <v-btn :class="['btn-secondary', activeCard === 'dateRange' ? 'active-button' : '']" style="padding: 0 40px; height: 36px; font-size: 14px; background-color: #000000; color: white;" @click="dateRangeCard" :disabled="!dateSelectRange">View</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="3">
        <v-card :class="['elevation-2', activeCard === 'selectPeriod' ? 'active-card' : '']" @click="setActiveCard('selectPeriod')" style="min-height: 180px; border-radius: 6px;">
          <v-card-title class="position-relative d-flex align-center" style="padding: 8px 16px;">
            <v-icon class="mr-2" size="28">mdi-calendar-multiple-check</v-icon>
            <span class="position-center" style="font-size: 16px; font-weight: 600;">Select Period</span>
          </v-card-title>
          <v-card-text style="padding: 4px 16px; padding-bottom: 40px;">
            <v-select
              v-model="selectedPeriod"
              :items="periodOptions"
              item-title="text"
              item-value="value"
              label="Select Period"
              outlined
              @update:modelValue="selectPeriodCard"
            ></v-select>
          </v-card-text>
          <v-card-actions class="justify-center mt-n4 mb-4" style="position: absolute; bottom: 0; width: 100%;">
            <v-btn :class="['btn-secondary', activeCard === 'selectPeriod' ? 'active-button' : '']" style="padding: 0 40px; height: 36px; font-size: 14px; background-color: #000000; color: white;" @click="selectPeriodCard" :disabled="!selectedPeriod">View</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <div
      v-if="activeCard === 'registerSales' && editableTable"
      style="display: flex; justify-content: space-between; align-items: center; padding: 2px 16px; height: 48px; background: linear-gradient(180deg, #1c2321 0%, #3A4542 100%); color: white; border-radius: 6px; margin-top: 12px;"
    >
      <h2 style="font-size: 18px; font-weight: 600; color: white;">
        Registering sales for {{
          new Date(registerSalesDate).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })
        }}
      </h2>
    </div>
    
    <v-row class="mt-5">
      <v-col cols="12">
        <div class="table-container">
          <v-data-table
              density="comfortable"
              :headers="dynamicHeaders"
              :items="filteredSalesData"  
              class="elevation-1"
              fixed-header
              style="min-height: 800px; max-height: calc(100vh - 200px);"
              :items-per-page="-1"
              v-model:sort-by="sortBy"
              :must-sort="mustSort"
              :class="{ 'comfortable-mode': true }"
              hide-default-footer
            >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.stageName }}</td>
                <td class="equal-width pa-0">
                  <v-text-field
                    v-if="activeCard === 'registerSales' && editableTable && (!item.locked || !item.locked.flirt4free)"
                    v-model="item.flirt4free"
                    hide-details
                    density="comfortable"
                    style="border-left: 3px solid #1EB3C6; width: 100%;"
                    @input="normalizeInput($event, item, 'flirt4free')"
                  ></v-text-field>
                  <span v-else class="sales-value">{{ formatValue(item.flirt4free) }}</span>
                </td>
                <td class="equal-width pa-0" v-if="activeCard === 'selectPeriod'">
                  <v-text-field
                    v-if="editableTable"
                    v-model="item.streamate_1"
                    hide-details
                    density="comfortable"
                    @input="normalizeInput($event, item, 'streamate_1')"
                  ></v-text-field>
                  <span v-else class="sales-value">{{ formatValue(item.streamate_1) }}</span>
                </td>
                <td class="equal-width pa-0" v-if="activeCard === 'selectPeriod'">
                  <v-text-field
                    v-if="editableTable"
                    v-model="item.streamate_2"
                    hide-details
                    density="comfortable"
                    @input="normalizeInput($event, item, 'streamate_2')"
                  ></v-text-field>
                  <span v-else class="sales-value">{{ formatValue(item.streamate_2) }}</span>
                </td>
                <td class="equal-width pa-0" v-else>
                  <v-text-field
                    v-if="activeCard === 'registerSales' && editableTable && (!item.locked || !item.locked.streamate)"
                    v-model="item.streamate"
                    hide-details
                    density="comfortable"
                    style="border-left: 3px solid #3399cc; width: 100%;"
                    @input="normalizeInput($event, item, 'streamate')"
                  ></v-text-field>
                  <span v-else class="sales-value">{{ formatValue(item.streamate) }}</span>
                </td>
                <td class="equal-width pa-0">
                  <v-text-field
                    v-if="activeCard === 'registerSales' && editableTable && (!item.locked || !item.locked.livejasmin)"
                    v-model="item.livejasmin"
                    hide-details
                    density="comfortable"
                    style="border-left: 3px solid #B8323C; width: 100%;"
                    @input="normalizeInput($event, item, 'livejasmin')"
                  ></v-text-field>
                  <span v-else class="sales-value">{{ formatValue(item.livejasmin) }}</span>
                </td>
                <td class="equal-width pa-0">
                  <v-text-field
                    v-if="activeCard === 'registerSales' && editableTable && (!item.locked || !item.locked.chaturbate)"
                    v-model="item.chaturbate"
                    hide-details
                    density="comfortable"
                    style="border-left: 3px solid #F9B661; width: 100%;"
                    @input="normalizeInput($event, item, 'chaturbate')"
                  ></v-text-field>
                  <span v-else class="sales-value">{{ formatValue(item.chaturbate) }}</span>
                </td>
                <td class="equal-width pa-0">
                  <v-text-field
                    v-if="activeCard === 'registerSales' && editableTable && (!item.locked || !item.locked.stripchat)"
                    v-model="item.stripchat"
                    hide-details
                    density="comfortable"
                    style="border-left: 3px solid #78943d; width: 100%;"
                    @input="normalizeInput($event, item, 'stripchat')"
                  ></v-text-field>
                  <span v-else class="sales-value">{{ formatValue(item.stripchat) }}</span>
                </td>
                <td class="equal-width pa-0">
                  <v-text-field
                    v-if="activeCard === 'registerSales' && editableTable && (!item.locked || !item.locked.xlove)"
                    v-model="item.xlove"
                    hide-details
                    density="comfortable"
                    style="border-left: 3px solid #990102; width: 100%;"
                    @input="normalizeInput($event, item, 'xlove')"
                  ></v-text-field>
                  <span v-else class="sales-value">{{ formatValue(item.xlove) }}</span>
                </td>
                <td class="equal-width pa-0">
                  <span class="sales-value">{{ formatValue(item.total) }}</span>
                </td>
              </tr>
            </template>
            <template v-slot:body.append>
              <tr class="totals-row">
                <td class="total-label">Total</td>
                <td class="equal-width pa-0">
                  <span class="sales-value">{{ formatValue(totalColumn('flirt4free')) }}</span>
                </td>
                <td v-if="activeCard === 'selectPeriod'" class="equal-width pa-0">
                  <span class="sales-value">{{ formatValue(totalColumn('streamate_1')) }}</span>
                </td>
                <td v-if="activeCard === 'selectPeriod'" class="equal-width pa-0">
                  <span class="sales-value">{{ formatValue(totalColumn('streamate_2')) }}</span>
                </td>
                <td v-else class="equal-width pa-0">
                  <span class="sales-value">{{ formatValue(totalColumn('streamate')) }}</span>
                </td>
                <td class="equal-width pa-0">
                  <span class="sales-value">{{ formatValue(totalColumn('livejasmin')) }}</span>
                </td>
                <td class="equal-width pa-0">
                  <span class="sales-value">{{ formatValue(totalColumn('chaturbate')) }}</span>
                </td>
                <td class="equal-width pa-0">
                  <span class="sales-value">{{ formatValue(totalColumn('stripchat')) }}</span>
                </td>
                <td class="equal-width pa-0">
                  <span class="sales-value">{{ formatValue(totalColumn('xlove')) }}</span>
                </td>
                <td class="equal-width pa-0">
                  <span class="sales-value">{{ formatValue(grandTotal()) }}</span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
        <v-btn
          v-if="editableTable"
          @click="saveSalesData"
          :style="floatingBtnStyle"
          icon
        >
          <v-icon size="30">mdi-content-save</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import secureAxios from '@/utils/secureAxios';
import { toast } from 'vue3-toastify';
import debounce from 'lodash/debounce';

export default {
  name: "SalesPage",
  data() {
    return {
      activeTab: 'studio',
      activeCard: 'dateRange',
      tabs: [
        { value: 'morning', label: 'Morning' },
        { value: 'evening', label: 'Evening' },
        { value: 'night', label: 'Night' },
        { value: 'satellite', label: 'Satellite' },
        { value: 'lata', label: 'Lata' },
        { value: 'active', label: 'Active' },
      ],
      registerSalesDate: null,
      dailySalesDate: new Date(),
      dateSelectRange: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
      periods: [],
      periodOptions: [],
      selectedPeriod: null,
      salesData: [],
      editableTable: false,
      sortBy: [{ key: 'stageName', order: 'asc' }],
      mustSort: true,
      isDocked: false,
    };
  },
  computed: {
    dynamicHeaders() {
      const baseHeaders = [
        { title: 'Stage Name', key: 'stageName', sortable: true },
        { title: 'Flirt4Free', key: 'flirt4free', sortable: true },
      ];

      const extraHeaders = [];

      if (this.activeCard === 'selectPeriod') {
        extraHeaders.push(
          { title: 'Streamate 1', key: 'streamate_1', sortable: true },
          { title: 'Streamate 2', key: 'streamate_2', sortable: true }
        );
      } else {
        extraHeaders.push({ title: 'Streamate', key: 'streamate', sortable: true });
      }

      extraHeaders.push(
        { title: 'LiveJasmin', key: 'livejasmin', sortable: true },
        { title: 'Chaturbate', key: 'chaturbate', sortable: true },
        { title: 'Stripchat', key: 'stripchat', sortable: true },
        { title: 'XLove', key: 'xlove', sortable: true },
        { title: 'Total', key: 'total', sortable: true }
      );

      return baseHeaders.concat(extraHeaders);
    },
    floatingBtnStyle() {
      return {
        position: this.isDocked ? 'static' : 'fixed',
        bottom: this.isDocked ? 'auto' : '24px',
        right: '24px',
        backgroundColor: '#1976d2',
        color: '#fff',
        zIndex: 10,
      };
    },
    // NEW: Add filteredSalesData to handle active/sales visibility
    filteredSalesData() {
      return this.salesData.filter(item => {
        const hasSales = this.hasSales(item);
        const isActive = item.status === 'Active';

        // Only include models that are active or have sales
        if (!hasSales && !isActive) return false;

        switch (this.activeTab) {
          case 'studio':
            return ['Morning', 'Evening', 'Night'].includes(item.location);
          case 'morning':
            return item.location === 'Morning';
          case 'evening':
            return item.location === 'Evening';
          case 'night':
            return item.location === 'Night';
          case 'satellite':
            return item.location === 'Satellite';
          case 'lata':
            return item.location === 'Lata';
          case 'active':
            return isActive;
          default:
            return true;
        }
      });
    }
  },
  created() {
    this.initialize();
  },
  watch: {
    dateSelectRange(newRange) {
      if (newRange.length === 2) {
        console.log("📅 New date range selected:", newRange);
        this.viewRangeSales();
      }
    },
    activeTab(newTab) {
      console.log(`🚀 Tab changed to: ${newTab}`);
      this.viewRangeSales();
    }
  },
  methods: {
    async fetchPeriods() {
      try {
        const response = await secureAxios.get('/api/sales/periods');
        this.periods = response.data;
        this.periodOptions = this.periods.map(period => ({
          value: period.id,
          text: period.name,
          payment_date: period.payment_date 
        }));
        console.log('Fetched periods:', this.periodOptions);

        const today = new Date();
        this.periods.sort((a, b) => new Date(a.payment_date) - new Date(b.payment_date));

        let currentPeriod = this.periods.find(period => {
          const paymentDate = new Date(period.payment_date);
          return today <= paymentDate;
        }) || this.periods[this.periods.length - 1];

        this.selectedPeriod = currentPeriod ? currentPeriod.id : this.periodOptions[0]?.value;
        console.log('Default selected period:', this.selectedPeriod);

        if (this.activeCard === 'selectPeriod') {
          await this.viewPeriodSales();
        }
      } catch (error) {
        console.error('❌ Error fetching periods:', error);
        toast.error('Failed to fetch periods');
      }
    },
    formatValue(value) {
      if (value === null || value === "" || parseFloat(value) === 0) return "";
      return "$" + parseFloat(value).toFixed(2);
    },
    normalizeInput(event, item, field) {
      let value = event.target.value || event;
      if (typeof value === 'string') {
        value = value.replace(',', '.');
        item[field] = value.match(/^-?\d*\.?\d{0,2}$/) ? value : parseFloat(value).toFixed(2);
      }
      item.total = this.calculateTotal(item);
    },
    handleDateRangeSelection(newRange) {
      console.log('📅 Date range selected:', newRange);
      if (newRange.length === 2) {
        this.$nextTick(() => {
          if (this.$refs.datePicker) {
            this.$refs.datePicker.isActive = false;
          }
        });
      }
    },
    setActiveCard(card) {
      this.activeCard = card;
      if (card === 'selectPeriod') {
        this.salesData = this.salesData.map(item => ({
          ...item,
          flirt4free: "",
          streamate_1: "",
          streamate_2: "",
          streamate: "",
          livejasmin: "",
          chaturbate: "",
          stripchat: "",
          xlove: "",
          total: 0
        }));
      }
    },
    async registerSalesCard() {
      this.setActiveCard('registerSales');
      await this.registerSales();
    },
    async dailySalesCard() {
      this.setActiveCard('dailySales');
      await this.viewDailySales();
    },
    async dateRangeCard() {
      console.log('📌 View Date Range button clicked. Fetching sales for:', this.dateSelectRange);
      this.setActiveCard('dateRange');
      await this.viewRangeSales();
    },
    selectPeriodCard: debounce(async function() {
      this.setActiveCard('selectPeriod');
      await this.viewPeriodSales();
    }, 300),
    async registerSales() {
      if (!this.registerSalesDate) {
        toast.error('Please select a date before registering sales');
        return;
      }
      const formattedDate = new Date(this.registerSalesDate).toISOString().split("T")[0];
      console.log("Registering sales for date", formattedDate);
      try {
        // Use updated /date/:date endpoint directly
        const salesResponse = await secureAxios.get(`/api/sales/date/${formattedDate}`);
        this.salesData = salesResponse.data.map(row => ({
          modelId: row.model_id,
          stageName: row.stage_name,
          status: row.status,
          location: row.location,
          flirt4free: parseFloat(row.flirt4free) > 0 ? parseFloat(row.flirt4free).toFixed(2) : "",
          streamate: parseFloat(row.streamate) > 0 ? parseFloat(row.streamate).toFixed(2) : "",
          livejasmin: parseFloat(row.livejasmin) > 0 ? parseFloat(row.livejasmin).toFixed(2) : "",
          chaturbate: parseFloat(row.chaturbate) > 0 ? parseFloat(row.chaturbate).toFixed(2) : "",
          stripchat: parseFloat(row.stripchat) > 0 ? parseFloat(row.stripchat).toFixed(2) : "",
          xlove: parseFloat(row.xlove) > 0 ? parseFloat(row.xlove).toFixed(2) : "",
          locked: row.locked || {
            flirt4free: false,
            streamate: false,
            livejasmin: false,
            chaturbate: false,
            stripchat: false,
            xlove: false
          },
          total: 0
        })).map(item => {
          item.total = this.calculateTotal(item);
          return item;
        });
        console.log('Loaded salesData:', this.salesData);
        this.editableTable = true;
      } catch (error) {
        console.error("❌ Error registering sales:", error);
        toast.error('Failed to register sales');
      }
    },
    async viewDailySales() {
    if (!this.dailySalesDate) {
      toast.error('Please select a date');
      return;
    }
    // Handle both Date and string inputs
    const dateObj = this.dailySalesDate instanceof Date
      ? this.dailySalesDate
      : new Date(this.dailySalesDate);
    if (isNaN(dateObj)) {
      toast.error('Invalid date selected');
      return;
    }
    const formattedDate = dateObj.toISOString().split("T")[0];
    console.log("Viewing daily sales for", formattedDate);
    try {
      const salesResponse = await secureAxios.get(`/api/sales/date/${formattedDate}`);
      this.salesData = salesResponse.data.map(row => ({
        modelId: row.model_id,
        stageName: row.stage_name,
        status: row.status,
        location: row.location,
        flirt4free: parseFloat(row.flirt4free) > 0 ? parseFloat(row.flirt4free).toFixed(2) : "",
        streamate: parseFloat(row.streamate) > 0 ? parseFloat(row.streamate).toFixed(2) : "",
        livejasmin: parseFloat(row.livejasmin) > 0 ? parseFloat(row.livejasmin).toFixed(2) : "",
        chaturbate: parseFloat(row.chaturbate) > 0 ? parseFloat(row.chaturbate).toFixed(2) : "",
        stripchat: parseFloat(row.stripchat) > 0 ? parseFloat(row.stripchat).toFixed(2) : "",
        xlove: parseFloat(row.xlove) > 0 ? parseFloat(row.xlove).toFixed(2) : "",
        total: 0,
      })).map(item => {
        item.total = this.calculateTotal(item);
        return item;
      });
      this.editableTable = false;
    } catch (error) {
      console.error('❌ Error fetching daily sales:', error);
      toast.error('Failed to fetch daily sales');
    }
  },
    async viewRangeSales() {
      if (!this.dateSelectRange || this.dateSelectRange.length < 2) {
        toast.error('Please select a valid date range');
        return;
      }
      const dateArray = [...this.dateSelectRange].map(d => new Date(d)).sort((a, b) => a - b);
      const startDate = dateArray[0].toISOString().split("T")[0];
      const endDate = dateArray[dateArray.length - 1].toISOString().split("T")[0];
      console.log(`🚀 Fetching sales data from ${startDate} to ${endDate}`);
      try {
        // Use updated /range endpoint
        const salesResponse = await secureAxios.get(`/api/sales/range/${startDate}/${endDate}`);
        this.salesData = salesResponse.data.map(row => ({
          modelId: row.model_id,
          stageName: row.stage_name,
          status: row.status,
          location: row.location,
          flirt4free: row.flirt4free ? parseFloat(row.flirt4free).toFixed(2) : "",
          streamate: row.streamate ? parseFloat(row.streamate).toFixed(2) : "",
          livejasmin: row.livejasmin ? parseFloat(row.livejasmin).toFixed(2) : "",
          chaturbate: row.chaturbate ? parseFloat(row.chaturbate).toFixed(2) : "",
          stripchat: row.stripchat ? parseFloat(row.stripchat).toFixed(2) : "",
          xlove: row.xlove ? parseFloat(row.xlove).toFixed(2) : "",
          total: 0
        })).map(item => {
          item.total = this.calculateTotal(item);
          return item;
        });
        this.editableTable = false;
      } catch (error) {
        console.error("❌ Error fetching range sales:", error);
        toast.error('Failed to fetch range sales');
      }
    },
    async viewPeriodSales() {
      if (!this.selectedPeriod) {
        console.log("No period selected yet, keeping table blank");
        this.salesData = this.filterModelsByTab(await secureAxios.get('/models').then(res => res.data))
          .map(model => {
            const item = {
              modelId: model.id,
              stageName: model.stageName,
              status: model.status,
              location: model.location || 'Unknown',
              flirt4free: "",
              streamate_1: "",
              streamate_2: "",
              streamate: "",
              livejasmin: "",
              chaturbate: "",
              stripchat: "",
              xlove: "",
              total: 0
            };
            item.total = this.calculateTotal(item);
            return item;
          });
        this.editableTable = false;
        return;
      }
      console.log("Viewing sales for period", this.selectedPeriod);
      try {
        // Use updated /period endpoint
        const salesResponse = await secureAxios.get(`/api/sales/period/${this.selectedPeriod}`);
        this.salesData = salesResponse.data.map(row => ({
          modelId: row.model_id,
          stageName: row.stage_name,
          status: row.status,
          location: row.location,
          flirt4free: row.flirt4free ? parseFloat(row.flirt4free).toFixed(2) : "",
          streamate_1: row.streamate_1 ? parseFloat(row.streamate_1).toFixed(2) : "",
          streamate_2: row.streamate_2 ? parseFloat(row.streamate_2).toFixed(2) : "",
          streamate: row.streamate ? parseFloat(row.streamate).toFixed(2) : "",
          livejasmin: row.livejasmin ? parseFloat(row.livejasmin).toFixed(2) : "",
          chaturbate: row.chaturbate ? parseFloat(row.chaturbate).toFixed(2) : "",
          stripchat: row.stripchat ? parseFloat(row.stripchat).toFixed(2) : "",
          xlove: row.xlove ? parseFloat(row.xlove).toFixed(2) : "",
          total: 0
        })).map(item => {
          item.total = this.calculateTotal(item);
          return item;
        });
        this.editableTable = false;
      } catch (error) {
        console.error('❌ Error fetching period sales:', error);
        toast.error('Failed to fetch period sales');
      }
    },
    async initialize() {
      try {
        await this.fetchPeriods();
        await this.viewRangeSales();
        console.log('Initial salesData:', this.salesData);
      } catch (error) {
        console.error('Error during initialization:', error);
        toast.error('Failed to initialize sales data');
      }
    },
    filterModelsByTab(models) {
      let filteredModels = models.filter(model => model.status === 'Active');
      switch (this.activeTab) {
        case 'studio':
          filteredModels = filteredModels.filter(model => ['Morning', 'Evening', 'Night'].includes(model.location));
          break;
        case 'morning':
          filteredModels = filteredModels.filter(model => model.location === 'Morning');
          break;
        case 'evening':
          filteredModels = filteredModels.filter(model => model.location === 'Evening');
          break;
        case 'night':
          filteredModels = filteredModels.filter(model => model.location === 'Night');
          break;
        case 'satellite':
          filteredModels = filteredModels.filter(model => model.location === 'Satellite');
          break;
        case 'lata':
          filteredModels = filteredModels.filter(model => model.location === 'Lata');
          break;
        case 'active':
          break;
        default:
          break;
      }
      console.log(`Filtered models for tab "${this.activeTab}":`, filteredModels);
      return filteredModels;
    },
    mergeSalesData(models, sales) {
      const salesMap = {};
      sales.forEach(sale => {
        const modelId = sale.model_id;
        if (!salesMap[modelId]) {
          salesMap[modelId] = {
            modelId: modelId,
            stageName: sale.stage_name,
            flirt4free: "",
            streamate: "",
            livejasmin: "",
            chaturbate: "",
            stripchat: "",
            xlove: "",
            total: 0
          };
        }
        const flirt4free = parseFloat(salesMap[modelId].flirt4free || 0) + parseFloat(sale.flirt4free || 0);
        salesMap[modelId].flirt4free = flirt4free ? flirt4free.toFixed(2) : "";
        const streamate = parseFloat(salesMap[modelId].streamate || 0) + parseFloat(sale.streamate || 0);
        salesMap[modelId].streamate = streamate ? streamate.toFixed(2) : "";
        const livejasmin = parseFloat(salesMap[modelId].livejasmin || 0) + parseFloat(sale.livejasmin || 0);
        salesMap[modelId].livejasmin = livejasmin ? livejasmin.toFixed(2) : "";
        const chaturbate = parseFloat(salesMap[modelId].chaturbate || 0) + parseFloat(sale.chaturbate || 0);
        salesMap[modelId].chaturbate = chaturbate ? chaturbate.toFixed(2) : "";
        const stripchat = parseFloat(salesMap[modelId].stripchat || 0) + parseFloat(sale.stripchat || 0);
        salesMap[modelId].stripchat = stripchat ? stripchat.toFixed(2) : "";
        const xlove = parseFloat(salesMap[modelId].xlove || 0) + parseFloat(sale.xlove || 0);
        salesMap[modelId].xlove = xlove ? xlove.toFixed(2) : "";
        salesMap[modelId].total = this.calculateTotal(salesMap[modelId]);
      });
      const merged = models.map(model => {
        const item = salesMap[model.id] || {
          modelId: model.id,
          stageName: model.stageName,
          flirt4free: "",
          streamate: "",
          livejasmin: "",
          chaturbate: "",
          stripchat: "",
          xlove: "",
          total: 0
        };
        item.total = this.calculateTotal(item);
        return item;
      });
      return merged;
    },
    // NEW: Add hasSales helper
    hasSales(item) {
      const fields = this.activeCard === 'selectPeriod'
        ? ['flirt4free', 'streamate_1', 'streamate_2', 'livejasmin', 'chaturbate', 'stripchat', 'xlove']
        : ['flirt4free', 'streamate', 'livejasmin', 'chaturbate', 'stripchat', 'xlove'];
      return fields.some(field => parseFloat(item[field]) > 0);
    },
    calculateTotal(item) {
      const streamateTotal = this.activeCard === 'selectPeriod'
        ? (parseFloat(item.streamate_1) || 0) + (parseFloat(item.streamate_2) || 0)
        : parseFloat(item.streamate) || 0;
      return [
        item.flirt4free,
        streamateTotal,
        item.livejasmin,
        item.chaturbate,
        item.stripchat,
        item.xlove
      ].reduce((acc, val) => acc + (parseFloat(val) || 0), 0);
    },
    async saveSalesData() {
      try {
        const formattedDate = new Date(this.registerSalesDate).toISOString().split("T")[0];
        console.log('Preparing sales data for date:', formattedDate);

        const originalResponse = await secureAxios.get(`/api/sales/date/${formattedDate}`);
        const originalData = originalResponse.data;

        const updates = [];
        const deletions = [];

        this.salesData.forEach(item => {
          const salesValues = {
            model_id: item.modelId,
            stage_name: item.stageName,
            date: formattedDate,
            flirt4free: parseFloat(item.flirt4free) || 0,
            streamate: parseFloat(item.streamate) || 0,
            livejasmin: parseFloat(item.livejasmin) || 0,
            chaturbate: parseFloat(item.chaturbate) || 0,
            stripchat: parseFloat(item.stripchat) || 0,
            xlove: parseFloat(item.xlove) || 0,
          };

          const original = originalData.find(o => o.model_id === item.modelId) || {
            flirt4free: 0,
            streamate: 0,
            livejasmin: 0,
            chaturbate: 0,
            stripchat: 0,
            xlove: 0,
          };

          const hasNonZero = Object.values(salesValues)
            .slice(3)
            .some(value => value >= 0.01 || value <= -0.01);
          const wasNonZero = Object.values(original)
            .slice(3)
            .some(value => value >= 0.01 || value <= -0.01);

          if (hasNonZero) {
            updates.push(salesValues);
          } else if (wasNonZero && !hasNonZero) {
            deletions.push({ model_id: item.modelId, date: formattedDate });
          }
        });

        console.log('Updates to save:', updates);
        console.log('Deletions to process:', deletions);

        if (updates.length > 0) {
          const updateResponse = await secureAxios.post('/api/sales', updates);
          console.log('Sales data saved successfully:', updateResponse.data);
          toast.success(`Sales data saved successfully for ${new Date(this.registerSalesDate).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}`);
        } else {
          console.log('No non-zero sales data to save');
        }

        if (deletions.length > 0) {
          const deleteResponse = await secureAxios.delete('/api/sales', { data: deletions });
          console.log('Sales data deleted successfully:', deleteResponse.data);
          toast.success('Zeroed sales entries removed!');
        } else {
          console.log('No entries to delete');
        }

        this.editableTable = false;
        this.dailySalesDate = new Date(this.registerSalesDate);
        this.registerSalesDate = null;
        this.salesData = [];
        this.activeCard = 'dailySales';
        await this.viewDailySales();
      } catch (error) {
        console.error('❌ Error saving/deleting sales data:', error);
        toast.error('Failed to save or delete sales data');
      }
    },
    totalColumn(field) {
      if (field === 'total') return this.grandTotal();
      return this.filteredSalesData.reduce((sum, item) => sum + (parseFloat(item[field]) || 0), 0).toFixed(2);
    },
    grandTotal() {
      return this.filteredSalesData.reduce((sum, item) => sum + parseFloat(this.calculateTotal(item) || 0), 0).toFixed(2);
    },
    handleScroll() {
      const container = document.querySelector('.table-container');
      if (!container) return;
      const bottomGap = container.scrollHeight - container.scrollTop - container.clientHeight;
      this.isDocked = bottomGap < 60;
    },
    async cancelRegisterSales() {
      if (this.registerSalesDate) {
        this.dailySalesDate = new Date(this.registerSalesDate); // Copy as Date
      } else {
        this.dailySalesDate = new Date(); // Fallback to today
      }
      this.registerSalesDate = null;
      this.editableTable = false;
      this.salesData = [];
      this.activeCard = 'dailySales';
      await this.viewDailySales();
      toast.info("Sales registration canceled.");
    },
  },
  mounted() {
    const container = document.querySelector('.table-container');
    if (container) container.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    const container = document.querySelector('.table-container');
    if (container) container.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style scoped>
.dashboard-tab .v-tab {
  background-color: white;
  color: #2C74B3;
}
.active-card {
  border: 2px solid #1976d2;
}
.v-card-title {
  position: relative;
}
.position-center {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.v-data-table tbody tr:nth-child(odd) {
  background-color: #ffffff;
}
.v-data-table tbody tr:nth-child(even) {
  background-color: #f0f4f8;
}

.totals-row {
  position: sticky;
  bottom: 0;
  background-color: #f5f5f5;
}
.totals-row td {
  font-weight: bold;
  text-align: left;
}

:deep(.equal-width) {
  width: 138px; /* or whatever value fits all columns cleanly */
  min-width: 138px;
  max-width: 138px;
}
.sales-value {
  display: inline-block;
  width: 100%;
  padding: 0 16px; /* top/right/bottom/left */
}
.table-container {
  max-height: calc(100vh - 200px); /* or 800px */
  overflow-y: auto;
  position: relative; /* ← THIS is key */
}
</style>